export default __webpack_public_path__ + "static/media/image-chair-learn-w.4b5b90cf.webp";